import { useMediaQuery } from '@mui/material';
import { IBudgetService } from '../../createAndEdit/types';
import CoverageBadge from '../../createAndEdit/components/CoverageBadge';
import BudgetCurrencyInput from '../../createAndEdit/components/BudgetCurrencyInput';
import { parseDiscountPercent } from '../../createAndEdit/utils/budgetCalculations';
import { ITruckerPayPlanData } from '../../../../models/truckerPayPlan';

interface ISummaryOfServicesProps {
  service: IBudgetService;
  serviceIndex: number;
	truckerPay?: ITruckerPayPlanData | undefined
}

const SummaryOfServices = (props: ISummaryOfServicesProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const observation = props.service.observation;
  const hasObservation = observation && 
    typeof observation === 'string' && 
    observation.trim() !== '';

	const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

	const parseQuantityToNumber = (qty: string | number | undefined): number => {
		if (qty === undefined || qty === null) return 0;
		const qtyStr = String(qty);
		const clean = qtyStr.replace(/[^\d.,]/g, '').replace(',', '.');
		return Number.parseFloat(clean) || 0;
	};
	
	const visibleItems = (props.service.items || []).filter((item) => {
		if (item.removed === true) return false;
		const quantity = parseQuantityToNumber(item.quantity);
		return quantity > 0;
	});

	const calculatedSubtotal = () => {
		return visibleItems.reduce((sum, item) => {
			if (item.isCovered === true) return sum;
			return sum + (parseQuantityToNumber(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100));
		}, 0);
	};

	const balance = props.truckerPay?.availableCoverageBalance ?? 0;

	const budgetHasProductWithoutCoverage =  props.service.items.some(item => !item.isCovered);

	const amountToBePaid = calculatedSubtotal() - balance < 0 ? 0 : calculatedSubtotal() - balance;
	
  return (
    <div className={`display-flex justify-content-start align-items-center border padding-y-25 padding-x-15 border-gray-200 rounded-md ${isMobile ? 'p-3 my-4' : 'my-6'}`}>
			<div className='display-flex align-items-center'>
				<p className='text-medium text-size-16 margin-right-10'>Sob medida</p>
				<span className="badge badge-muted text-size-14 text-color-darkest margin-right-10">
					{props.service.serviceName?.trim() || props.service.serviceId}
				</span>
				<div className='width-150 margin-right-10'>
					<CoverageBadge isCovered={!budgetHasProductWithoutCoverage} notCoveredReason={''} />
				</div>
				<p className='text-size-16 text-color-darker'>Valor a ser utilizado do saldo</p>
				<div className='width-150'>
					<BudgetCurrencyInput
						ref={null}
						value={''}
						onChange={(value) => {}}
						disabled={false}
						isRemoved={false}
						isChanged={false}
					/>
				</div>
			</div>

			<div className='display-flex flex-column width-300 gap-5 '>
				<div className='display-flex justify-content-end gap-5 text-[#2A374099] text-medium'>
					<p className='margin-0'>Subtotal do serviço:</p>
					<p className='margin-0'>{formatCurrency(calculatedSubtotal())}</p>
				</div>
				{budgetHasProductWithoutCoverage ? (
					<>
						<div className='display-flex justify-content-end gap-5 text-color-success text-medium'>
							<p className='margin-0'>Saldo utilizado:</p>
							<p className='margin-0'>{formatCurrency(balance)}</p>
						</div>
						<div className='display-flex justify-content-end gap-5 text-color-darkest text-medium'>
							<p className='margin-0'>Valor a ser pago:</p>
							<p className='margin-0'>{formatCurrency(amountToBePaid)}</p>
						</div>
					</>
				) : null}
			</div>
      {/* {hasObservation && observation && (
        <div className="mt-4 pl-4">
          <DetailServiceObservation observation={observation} />
        </div>
      )} */}
    </div>
  );
};

export default SummaryOfServices;
